import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Handle basename redirects BEFORE React Router renders
// This fixes Stripe redirects that don't include the basename
const basename = '/trackai';
const pathname = window.location.pathname;
const search = window.location.search;
const hash = window.location.hash;

// List of routes that require the basename
const routesNeedingBasename = [
  '/payment-success',
  '/select-plan',
  '/login',
  '/signup',
  '/verify-otp',
  '/forgot-password',
  '/settings',
  '/crm'
];

// Check if current path needs basename but doesn't have it
if (!pathname.startsWith(basename)) {
  const needsRedirect = routesNeedingBasename.some(route => 
    pathname === route || pathname.startsWith(route + '/')
  );
  
  if (needsRedirect) {
    // Redirect to the correct path with basename
    const newPath = basename + pathname + search + hash;
    window.location.replace(newPath);
    // Don't render app - let the redirect happen
    // The page will reload with correct URL and then render
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
